import React from 'react';

export const CloudIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M17.5 19H8a5 5 0 0 1-1-9.9A7 7 0 0 1 20.5 12 3.5 3.5 0 0 1 17.5 19Z"/></svg>
);
export const GraphIcon = () => (
  <svg viewBox="0 0 24 24"><circle cx="12" cy="5" r="3"/><circle cx="5" cy="19" r="3"/><circle cx="19" cy="19" r="3"/><path d="M10.5 7.5 6.5 16.5M13.5 7.5l4 9M8 19h8"/></svg>
);
export const BarChartIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M4 19V5M4 19h16"/><rect x="7" y="11" width="3" height="5"/><rect x="12" y="8" width="3" height="8"/><rect x="17" y="5" width="3" height="11"/></svg>
);
export const GearIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M12 15.5A3.5 3.5 0 1 0 12 8a3.5 3.5 0 0 0 0 7.5Z"/><path d="M19.4 15a1.8 1.8 0 0 0 .36 2l.05.05a2.1 2.1 0 1 1-3 3l-.05-.05a1.8 1.8 0 0 0-2-.36 1.8 1.8 0 0 0-1.1 1.65V21a2.1 2.1 0 1 1-4.2 0v-.08a1.8 1.8 0 0 0-1.1-1.65 1.8 1.8 0 0 0-2 .36l-.05.05a2.1 2.1 0 1 1-3-3l.05-.05a1.8 1.8 0 0 0 .36-2A1.8 1.8 0 0 0 2.08 13H2a2.1 2.1 0 1 1 0-4.2h.08a1.8 1.8 0 0 0 1.65-1.1 1.8 1.8 0 0 0-.36-2l-.05-.05a2.1 2.1 0 1 1 3-3l.05.05a1.8 1.8 0 0 0 2 .36A1.8 1.8 0 0 0 9.5 1.42V1a2.1 2.1 0 1 1 4.2 0v.08a1.8 1.8 0 0 0 1.1 1.65 1.8 1.8 0 0 0 2-.36l.05-.05a2.1 2.1 0 1 1 3 3l-.05.05a1.8 1.8 0 0 0-.36 2A1.8 1.8 0 0 0 21.08 8H21a2.1 2.1 0 1 1 0 4.2h-.08A1.8 1.8 0 0 0 19.4 15Z"/></svg>
);
export const RocketIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M5 15c-1 1-1.5 3-1.5 5.5C6 20.5 8 20 9 19"/><path d="M9 15 5 11l5-5c4-4 8-3 10-2-1 2 2 6-2 10l-5 5-4-4Z"/><circle cx="15" cy="9" r="2"/><path d="M8 16l-2 2M12 20l-2 2"/></svg>
);
export const FactoryIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M3 21h18V9l-6 3V9l-6 3V5H3v16Z"/><path d="M7 16h2M12 16h2M17 16h2"/></svg>
);
export const BoltIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z"/></svg>
);
export const CartIcon = () => (
  <svg viewBox="0 0 24 24"><circle cx="9" cy="20" r="1.8"/><circle cx="18" cy="20" r="1.8"/><path d="M3 4h2l2.2 11.2A2 2 0 0 0 9.2 17H18a2 2 0 0 0 2-1.6L21 8H6"/></svg>
);
export const TruckIcon = () => (
  <svg viewBox="0 0 24 24"><path d="M3 7h12v10H3z"/><path d="M15 10h4l2 3v4h-6z"/><circle cx="7" cy="19" r="2"/><circle cx="18" cy="19" r="2"/></svg>
);
